import { createSelector } from 'reselect';

const selectUserEvaluationsState = state => state.UserEvaluations;

export const selectIsFetching = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.fetching
);

export const selectError = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.error
);

export const selectGetAllChatbotEvaluation = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.chatbots
);

export const selectGetAllAssignmentsEvaluation = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.assignments
);

export const selectGetAllClaimsEvaluation = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.claims
);

export const selectIsFetchingEventClaims = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.fetchingEventClaims
);

export const selectErrorEventClaims = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.errorEventClaims
);

export const selectEventClaimsEvaluation = createSelector(
  selectUserEvaluationsState,
  (state, props) => state.eventClaims
);
